const articleTemplate = require('./zendesk-article-template.html');
const atmArticleVoteMapper = require('./article-vote-mapper');

module.exports = function ArticleDirective(helpCenterService, $sce, atm) {
    return {
        restrict: 'E',
        scope: {
            articleId: '='
        },
        template: articleTemplate,
        link: function (scope) {
            scope.relatedArticles = [];
            scope.categories = [];
            scope.currentCategoryName = "";
            scope.currentSectionName = "";
            scope.sections = [];
            scope.topic = "";
            scope.isUpvoted = false;
            scope.isDownvoted = false;

            scope.$watch('articleId', function (articleId) {
                if (!articleId) return;

                helpCenterService.getArticleDetails(articleId)
                    .then(function (article) {
                        scope.article = article;
                        scope.$evalAsync();

                        // Use the service's built-in method to get category/section info
                        return helpCenterService.getCategoryAndSectionInfo(article.section_id)
                            .then(function (categorySectionInfo) {
                                if (categorySectionInfo) {
                                    scope.currentCategoryName = categorySectionInfo.categoryName;
                                    scope.currentSectionName = categorySectionInfo.sectionName;
                                    scope.currentCategoryId = categorySectionInfo.categoryId;
                                    scope.$evalAsync();
                                }
                                return article;
                            });
                    })
                    .then(function (article) {
                        // Only fetch related articles if we don't have them already
                        if (scope.relatedArticles.length === 0) {
                            return helpCenterService.getArticlesBySectionId(article.section_id)
                                .then(function (articles) {
                                    scope.relatedArticles = articles;
                                    scope.$evalAsync();
                                });
                        }
                    })
                    .catch(function (error) {
                        console.error("Error:", error);
                    });
            });

            scope.trustHtml = function (articleBody) {
                return $sce.trustAsHtml(articleBody);
            };

            scope.showHelpCenter = function () {
                scope.$parent.showLandingPageTemplate();
            };

            scope.showSection = function () {
                scope.$parent.showSectionsArticles(scope.currentCategoryId);
            };

            scope.voteArticle = function (voteType) {
                atm.push({
                    linkName: `web:article page:${scope.article.id}:helpfulness rating:${voteType}`
                }, atmArticleVoteMapper);
                if(voteType === 'yes'){
                    scope.isUpvoted = true;
                    scope.isDownvoted = false;
                }
                else{
                    scope.isDownvoted = true;
                    scope.isUpvoted = false;
                }
            };
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/zendesk-article-directive.js
 **/